import React from 'react';
import { ScrollReveal } from './ScrollReveal';
const PARTNERS = [{
  name: 'Align Technology',
  logo: 'https://cdn.rawproductionsgmbh.de/2n/logos/align-logo.png'
}, {
  name: 'BFS',
  logo: 'https://cdn.rawproductionsgmbh.de/2n/logos/bfs.png'
}, {
  name: 'DGZMK',
  logo: 'https://cdn.rawproductionsgmbh.de/2n/logos/DGZMK.png'
}, {
  name: 'Doctolib',
  logo: 'https://cdn.rawproductionsgmbh.de/2n/logos/Doctolib.png'
}, {
  name: 'Hu-Friedy Group',
  logo: 'https://cdn.rawproductionsgmbh.de/2n/logos/HuFriedyGroup-Logo.png'
}, {
  name: 'Kuraray',
  logo: 'https://cdn.rawproductionsgmbh.de/2n/logos/Kuraray-Logo.png'
}, {
  name: 'Kuraray Noritake',
  logo: 'https://cdn.rawproductionsgmbh.de/2n/logos/Kuraray-Noritake.png'
}, {
  name: 'Bien-Air',
  logo: 'https://cdn.rawproductionsgmbh.de/2n/logos/bienair.png'
}, {
  name: 'DGCZ Spezialistensiegel',
  logo: 'https://cdn.rawproductionsgmbh.de/2n/logos/dgacc88.png'
}, {
  name: 'American Dental',
  logo: 'https://cdn.rawproductionsgmbh.de/2n/logos/american-dental.jpg'
}, {
  name: 'APW',
  logo: 'https://cdn.rawproductionsgmbh.de/2n/logos/APW-Logo.png'
}, {
  name: 'Schütz Dental Micerium Group',
  logo: 'https://cdn.rawproductionsgmbh.de/2n/logos/schuetz-dental-micerium-group.png'
}, {
  name: 'Invisalign',
  logo: 'https://cdn.rawproductionsgmbh.de/2n/logos/invisalign.png'
}, {
  name: 'DGSZM',
  logo: 'https://cdn.rawproductionsgmbh.de/2n/logos/DGSZM.png'
}, {
  name: 'Dentognostics',
  logo: 'https://cdn.rawproductionsgmbh.de/2n/logos/dentognostics.png'
}, {
  name: 'Sonia',
  logo: 'https://cdn.rawproductionsgmbh.de/2n/logos/Sonia.webp'
}, {
  name: 'Starmed',
  logo: 'https://cdn.rawproductionsgmbh.de/2n/logos/starmed.jpeg'
}, {
  name: 'Straumann',
  logo: 'https://cdn.rawproductionsgmbh.de/2n/logos/straumann.png'
}, {
  name: 'Wawibox',
  logo: 'https://cdn.rawproductionsgmbh.de/2n/logos/wawibox.webp'
}];
export function PartnerLogos() {
  return <section className="py-12 md:py-20 bg-white border-t border-slate-100" data-id="element-616">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-617">
        <ScrollReveal variant="up" data-id="element-618">
          <div className="text-center mb-10 md:mb-14" data-id="element-619">
            <span className="text-[#59d0d4] font-extrabold tracking-widest uppercase text-sm mb-4 block" data-id="element-620">
              Netzwerk & Kooperationen
            </span>
            <h2 className="text-2xl md:text-4xl font-extrabold text-slate-700 tracking-tight" data-id="element-621">
              Unsere Partner
            </h2>
          </div>
        </ScrollReveal>

        <ScrollReveal variant="up" delay={150} data-id="element-622">
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6 md:gap-8 items-center justify-items-center" data-id="element-623">
            {PARTNERS.map(partner => <div key={partner.name} className="flex items-center justify-center p-4 sm:p-5 w-full h-24 sm:h-28" data-id="element-624">
                <img src={partner.logo} alt={partner.name} className="max-h-14 sm:max-h-16 max-w-full object-contain" data-id="element-625" />
              </div>)}
          </div>
        </ScrollReveal>
      </div>
    </section>;
}